import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() ?? "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ?? "";

export const appConfig = {
  supabaseUrl,
  supabaseAnonKey,
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY?.trim() ?? "",
  whatsappNumber: import.meta.env.VITE_WHATSAPP_NUMBER?.trim() ?? "",
  whatsappDefaultMessage: import.meta.env.VITE_WHATSAPP_DEFAULT_MESSAGE?.trim() ?? "",
  stagingMode: import.meta.env.VITE_STAGING_MODE === "true",
  useMockApi: import.meta.env.VITE_USE_MOCK_API === "true",
  isConfigured: Boolean(supabaseUrl && supabaseAnonKey),
};

export const supabase = appConfig.isConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        detectSessionInUrl: true,
      },
    })
  : null;
